import React from 'react';
import Video from './Video';

export default function videoPlugin(options) { // eslint-disable-line
  return {
    schema: {
      blocks: {
        video: {
          isVoid: true,
        },
      },
    },

    renderBlock(props, editor, next) {
      const { node } = props;
      if (node.type === 'video') {
        return <Video {...props} />;
      }
      return next();
    },
  };
}
